<div class="info-popover">
  <button
    aria-label="mehr Informationen"
    type="button"
    (click)="toggleVisibility(); setHeight()"
    class="info-icon"
    #icon
  ></button>
  <div class="popover-container" [style.visibility]="isHidden()" [style.height]="popoverHeight()">
    <div [style.visibility]="isHidden() ? 'hidden' : 'visible'" class="popover" #popover>
      {{ popoverText }}
    </div>
  </div>
</div>
